// extracted by mini-css-extract-plugin
module.exports = {"root":"root-nX9xj","date":"date-3Pem4"};